module.exports = __webpack_public_path__ + "img/health36_7-9-2021.67251f51.jpg";